import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import PageLoadingSpinner from "components/common/PageLoader";
import BreadCrumb from "components/common/BreadCrumb";
import { getDocumentTitle } from "utils/helpers";
import { WorkOrder } from "features/WorkOrders/types/work-order.types";
import { getWorkOrder } from "features/WorkOrders/services/WorkOrderService";
import WorkOrderOverviewContext from "./WorkOrderOverviewContext";
import Section from "./Section";

function WorkOrderOverview() {
  document.title = getDocumentTitle("Work Order Details");
  const { id } = useParams();
  const [workOrder, setWorkOrder] = useState<WorkOrder | null>(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!id) return;
    const numericId = Number(id);
    if (!Number.isFinite(numericId) || numericId <= 0) return;
    try {
      const res = await getWorkOrder(numericId);
      if (res.success && res.data) {
        setWorkOrder(res.data);
      } else {
        setWorkOrder(null);
      }
    } catch (err) {
      console.warn(err);
      setWorkOrder(null);
    }
  }, [id]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!id) {
        setLoading(false);
        setWorkOrder(null);
        return;
      }
      const numericId = Number(id);
      if (!Number.isFinite(numericId) || numericId <= 0) {
        setLoading(false);
        setWorkOrder(null);
        return;
      }
      setLoading(true);
      await refetch();
      if (!cancelled) setLoading(false);
    };
    void load();
    return () => {
      cancelled = true;
    };
  }, [id, refetch]);

  if (loading) {
    return <PageLoadingSpinner message="Loading work order…" />;
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Work order details"
          pageTitle="Work Orders"
          items={[{ label: "Work orders", path: "/work-orders" }]}
        />
        <WorkOrderOverviewContext.Provider value={{ workOrder, refetch }}>
          <Section />
        </WorkOrderOverviewContext.Provider>
      </Container>
    </div>
  );
}

export default WorkOrderOverview;
